/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ShipmentExport
 */
export interface ShipmentExport {
  /**
   *
   * @type {string}
   * @memberof ShipmentExport
   */
  fileName: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentExport
   */
  contentType: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentExport
   */
  base64Content: string;
}

/**
 * Check if a given object implements the ShipmentExport interface.
 */
export function instanceOfShipmentExport(
  value: object,
): value is ShipmentExport {
  if (!("fileName" in value) || value["fileName"] === undefined) return false;
  if (!("contentType" in value) || value["contentType"] === undefined)
    return false;
  if (!("base64Content" in value) || value["base64Content"] === undefined)
    return false;
  return true;
}

export function ShipmentExportFromJSON(json: any): ShipmentExport {
  return ShipmentExportFromJSONTyped(json, false);
}

export function ShipmentExportFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentExport {
  if (json == null) {
    return json;
  }
  return {
    fileName: json["fileName"],
    contentType: json["contentType"],
    base64Content: json["base64Content"],
  };
}

export function ShipmentExportToJSON(json: any): ShipmentExport {
  return ShipmentExportToJSONTyped(json, false);
}

export function ShipmentExportToJSONTyped(
  value?: ShipmentExport | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    fileName: value["fileName"],
    contentType: value["contentType"],
    base64Content: value["base64Content"],
  };
}
